import { useRef, useState } from 'react';
import { ModalSubmitDialog } from '../../../components/modalSubmitDialog.tsx';
import { OperatorSelect } from '../../../components/operatorSelect.tsx';
import { ManualTask } from '../../../types/sharedTypeImpl.ts';
import { trpc } from '../../../utils/trpc/trpc.ts';


export type CloseTaskMode = 'complete' | 'cancel';

interface Props {
    task: ManualTask;
    mode: CloseTaskMode;
    onSuccess: () => void;
    onClose: () => void;
}

export function CloseTaskDialog({
    task,
    mode,
    onSuccess,
    onClose,
}: Props) {
    const formRef = useRef<HTMLFormElement>(null);
    const [operator, setOperator] = useState('');

    const completeTaskMutation = trpc.tasks.completeManualTask.useMutation();
    const cancelTaskMutation = trpc.tasks.cancelManualTask.useMutation();


    async function handleSubmit() {
        if (!formRef.current?.checkValidity()) {
            formRef.current!.reportValidity();
            return;
        }

        try {
            if (mode === 'complete') {
                await completeTaskMutation.mutateAsync({ _id: task._id!, closedBy: operator });
            } else {
                await cancelTaskMutation.mutateAsync({ _id: task._id!, closedBy: operator });
            }
            onSuccess();
            onClose();
        } catch (e) {
            console.log(e);
            alert('Failed to create task');
        }
    }

    return (
        <ModalSubmitDialog
            frameStyle={{ width: '400px' }}
            isOpen={true}
            isSubmitting={completeTaskMutation.isPending || cancelTaskMutation.isPending}
            onSubmit={handleSubmit}
            onCancel={onClose}
        >
            <div>
                {mode === 'complete' ? 'Complete ' : 'Cancel '}
                task "{task.text}"?
            </div>
            <form ref={formRef} style={{ marginTop: '10px', }}>
                <OperatorSelect
                    style={{ width: '100%' }}
                    operatorInitials={operator}
                    onChange={(value) => setOperator(value)}
                    required={true}
                />
            </form>
        </ModalSubmitDialog>
    )
}
